import BaseModel from "../BaseModel";
import ContactType from "./ContactType";
import Customer from "./Customer";
import Subscription from "./Subscription";
import PhoneNumber from "./PhoneNumber";
import Address from "./Address";

export default class Contact extends BaseModel{
    static entity = 'contacts';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            name: this.attr(null),
            email: this.attr(null),
            phone: this.attr(null),
            alt_phone: this.attr(null),
            alt_email: this.attr(null),
            contact_type_id: this.attr(null),
            user_id: this.attr(null),
            phone_numbers: this.hasMany(PhoneNumber, 'contact_id'),
            contact_type: this.belongsTo(ContactType,'contact_type_id'),
            customer: this.belongsTo(Customer, 'customer_id', 'id'),
            email_subscriptions: this.hasMany(Subscription, 'contact_id'),
            address: this.hasMany(Address, 'customer_id', 'customer_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'contact_type', 'customer', 'email_subscriptions']
    }
    static route(){
        return '/contacts'
    }
}
